export default {
  primary: "#3D8ECD",
  secondary: "#272260",
  info: "#624DDB",
  byob: "#0E2F59",

  light: "#CDE9FF",
  "light-transparent": "#F7F8FA",
  dark: "#526C79",

  purple: {
    primary: "#BD47FB",
    light: "#B9BDEA",
  },

  orange: "#F27F16",

  red: {
    primary: "#FA2256",
  },

  green: {
    primary: "#11CABE",
    light: "#30E0A1",
  },

  "dark-base": "#22242C",

  gray: {
    5: "#FEFCFF",
    10: "#E5E5E5",
    30: "#B2B2B2",
    50: "#808080",
    60: "#666666",
    70: "#4D4D4D",
    80: "#333333",
    90: "#1A1A1A",
    100: "#141414",
    dashboard: "#1E1F25",
    darker: "#141518",
  },
};
